export function stageInit() {
  const stageCollapseItems = document.querySelectorAll("[data-collapse-title]") as NodeListOf<HTMLDivElement>;

  stageCollapseItems.forEach((item) => {
    item.addEventListener("click", () => {
      const collapse = item.closest("[data-collapse]") as HTMLDivElement;

      if (collapse.classList.contains("--opened")) {
        collapse.classList.remove("--opened");
      } else {
        collapse.classList.add("--opened");
      }
    });
  });
}
